/* src/app/admin-setting/assing-company-users/company-users-list/update-user-role-popup/update-user-role-popup.css */
::ng-deep update-user-role-popup.ng-star-inserted > div {
  margin-right: -24px;
  margin-left: -24px;
}
/*# sourceMappingURL=update-user-role-popup.css.map */
